import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _to_property_key } from "@swc/helpers/_/_to_property_key";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import { useLocaleKeys } from '~/i18n';
import { withNetTerms } from '../../settings-predicates';
import { ChipConnector } from '../ChipConnector/ChipConnector';
import { presentCollectionQuantifiers } from '../CollectionChips/collection-predicate';
import { CollectionChips } from '../CollectionChips/CollectionChips';
import { unknownArmChipKeys } from '../DraftsAiSearchChips.utils';
import { buildPredicateChipUnits, buildUnknownChipUnits } from './PredicateChips.utils';
export const PredicateChips = (param)=>{
    let { predicate, onChange, testIds } = param;
    const { t } = useLocaleKeys('pages.draftsDashboard.aiSearch');
    const setField = (key, value)=>{
        if (value == null) {
            const { [key]: _omit } = predicate, rest = _object_without_properties(predicate, [
                _to_property_key(key)
            ]);
            onChange(rest);
        } else {
            onChange(_object_spread_props(_object_spread({}, predicate), {
                [key]: value
            }));
        }
    };
    const setNetTerms = (value)=>{
        setField('paymentSettings', withNetTerms(predicate.paymentSettings, value));
    };
    const removeField = (key)=>{
        const indexable = _object_spread({}, predicate);
        const { [key]: _omit } = indexable, next = _object_without_properties(indexable, [
            _to_property_key(key)
        ]);
        onChange(next);
    };
    const callbacks = {
        onAgreementNameChange: (value)=>setField('agreementName', value),
        onClientNameChange: (value)=>setField('clientName', value),
        onContactNameChange: (value)=>setField('contactName', value),
        onStatusChange: (value)=>setField('status', value),
        onEffectiveDateChange: (value)=>setField('effectiveDate', value),
        onEffectiveDateModeChange: (value)=>setField('effectiveDateMode', value),
        onLastUpdatedAtChange: (value)=>setField('lastUpdatedAt', value),
        onLastModifiedByChange: (value)=>setField('lastModifiedBy', value),
        onNetTermsChange: setNetTerms,
        onPaymentSettingsChange: (value)=>setField('paymentSettings', value),
        onAgreementSettingsChange: (value)=>setField('agreementSettings', value),
        onServicesChange: (value)=>setField('services', value)
    };
    const units = [
        ...buildPredicateChipUnits({
            predicate,
            testIds,
            callbacks
        })
    ];
    if (predicate.packages != null && presentCollectionQuantifiers(predicate.packages).length > 0) {
        units.push({
            key: 'packages',
            node: /*#__PURE__*/ _jsx(CollectionChips, {
                testId: testIds.Packages,
                fieldLabel: t.packagesLabel(),
                nounLabel: t.packagesNoun(),
                collection: predicate.packages,
                toggleBiName: "drafts_ai_search_chip_toggle_packages_quantifier",
                removeBiName: "drafts_ai_search_chip_remove_packages",
                onChange: (value)=>setField('packages', value)
            })
        });
    }
    if (predicate.bundles != null && presentCollectionQuantifiers(predicate.bundles).length > 0) {
        units.push({
            key: 'bundles',
            node: /*#__PURE__*/ _jsx(CollectionChips, {
                testId: testIds.Bundles,
                fieldLabel: t.bundlesLabel(),
                nounLabel: t.bundlesNoun(),
                collection: predicate.bundles,
                toggleBiName: "drafts_ai_search_chip_toggle_bundles_quantifier",
                removeBiName: "drafts_ai_search_chip_remove_bundles",
                onChange: (value)=>setField('bundles', value)
            })
        });
    }
    units.push(...buildUnknownChipUnits({
        keys: unknownArmChipKeys(predicate),
        testIds,
        onRemove: removeField
    }));
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: units.map((unit, index)=>/*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    index > 0 && /*#__PURE__*/ _jsx(ChipConnector, {
                        testId: testIds.AndConnector(index - 1),
                        tone: "and"
                    }),
                    unit.node
                ]
            }, unit.key))
    });
};
